
const pixelTag = (newPixel: string) => {
  console.log('pixelTag-->', newPixel)
  try {
    //@ts-ignore
    window.dataLayer.push({
      conversion_name: newPixel,
    })
    //@ts-ignore
    window.dataLayer.push({
      event: "gtm.dom",
    })
  } catch (error) {
    console.log(error)
  }
}

export default pixelTag